import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { useJourneyNavigate } from '@/services/journeys/useJourneyNavigate';
import { logger } from '@/services/logger/logger';
import { useAppSelector } from '@/store/hooks';

export function usePaymentSuccess() {
  const transactionState = useAppSelector(state => state.transaction);

  const journeyNavigate = useJourneyNavigate();
  const navigate = useNavigate();

  const paymentSuccess = useCallback(() => {
    function doPaymentSuccess(): void {
      try {
        if (transactionState.successUrl) {
          logger.info(`Redirecting to successUrl: ${transactionState.successUrl}`);
          window.location.href = transactionState.successUrl;
        } else {
          journeyNavigate('success');
        }
      } catch (error) {
        logger.error('Error while navigating to step...');
        logger.error(error);
        void navigate('/not-found');
      }
    }

    return doPaymentSuccess();
  }, [transactionState, navigate, journeyNavigate]);

  return paymentSuccess;
}
